<template>
  <div class="main-select-wrapper">
    <div v-if="Boolean(label)" class="main-select-label-wrapper">
      <label
        :class="[
          'main-select-label',
          {
            'main-select-label_require': isRequired,
          },
        ]"
        :for="id"
        >{{ label }}</label
      >
      <img
        id="select-tooltip-icon"
        v-if="Boolean(tooltipValue)"
        class="main-select-info"
        src="../../files/select-info-icon.svg"
        alt="info-icon"
      />
      <main-tooltip
        isHtml
        target="select-tooltip-icon"
        v-if="Boolean(tooltipValue)"
        :tooltipValue="tooltipValue"
      />
    </div>

    <v-select
      :searchable="searchable"
      :clearable="clearable"
      :class="[
        'main-select',
        {
          'main-select_active': isSelectOpened,
          'main-select_invalid': Boolean(errorMessage),
        },
      ]"
      :inputId="inputId"
      :value="value"
      :options="options"
      :placeholder="placeholder"
      @input="$emit('input', $event)"
      @open="onOpenSelect"
      @close="onCloseSelect"
      :reduce="withReduce ? (option) => option.code : undefined"
    >
      <template v-slot:no-options="{ search, searching }">
        <template v-if="searching"
          >Не найдено результатов для {{ search }}.</template
        >
      </template>
      <template #option="{ label }">
        <p class="main-select-option">{{ label }}</p>
      </template>
    </v-select>
    <span
      class="invalid-feedback"
      style="display: block;"
      v-show="errorMessage"
      >{{ errorMessage }}</span
    >
  </div>
</template>

<script>
import MainTooltip from "./MainTooltip.vue";

export default {
  props: {
    label: {
      type: String,
      required: false,
    },
    id: {
      type: String,
      required: false,
    },
    inputId: {
      type: String,
      required: false,
    },
    value: {
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: "",
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    tooltipValue: {
      type: String,
      require: false,
    },
    errorMessage: {
      type: String,
      require: false,
    },
    searchable: {
      type: Boolean,
      require: false,
      default: true,
    },
    withReduce: {
      type: Boolean,
      require: false,
      default: false,
    },
  },
  components: { MainTooltip },
  data() {
    return {
      isSelectOpened: false,
    };
  },
  methods: {
    onOpenSelect() {
      this.isSelectOpened = true;
    },
    onCloseSelect() {
      this.isSelectOpened = false;
      // Снимает фокус с инпута после выбора элемента
      setTimeout(() => {
        document.activeElement.blur();
      }, 0);
    },
  },
};
</script>

<style>
.main-select-label {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: var(--black-color);
  margin-bottom: 0;
}

.main-select .vs__selected {
  font-family: "Inter", sans-serif;
  display: block;
  max-width: 600px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--black-color);
  margin-top: 6px;
}

.main-select-label_require::after {
  content: " *";
  color: var(--error-color);
}

.main-select .vs__dropdown-toggle {
  height: 36px;
  border: 1px solid var(--border-color);
  transition: border 0.15s ease-out;
}

.main-select:hover .vs__dropdown-toggle {
  border: 1px solid var(--primary-color);
}

.main-select_invalid .vs__dropdown-toggle {
  border: 1px solid var(--error-color);
}

.main-select_active .vs__dropdown-toggle {
  border: 1px solid var(--secondary-color);
}

.main-select .vs__search {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--grey-3-color);
}

.main-select:focus-within li {
  background-color: transparent;
}

.main-select-option {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--black-color);
  margin-bottom: 16px;
  padding: 0;
}

.main-select-label-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 4px;
}

.main-select-info {
  width: 16px;
  height: 16px;
  margin-left: 4px;
  color: var(--grey-icon-color);
}
</style>
